module.exports = __webpack_public_path__ + "static/media/Zimble_Word_Bluish.23c118fe.png";